import { DateRange } from '@mui/icons-material'
import { Button, Stack, Typography } from '@mui/material'
import { subDays } from 'date-fns'
import useGreetings from '../../../../../hooks/useGreetings'

export default function PageHeader({handleOnHeaderButtonClick}:{handleOnHeaderButtonClick: ()=>void}) {

    
    return(

        <Stack direction="row" justifyContent="space-between" alignItems="center" >
                
            <Stack direction="column">
                <Typography variant="h6" sx={{color: "grey.200", fontWeight: "bold" }}>
                    {useGreetings()}, Samuel.
                </Typography>
                <Typography variant="subtitle2" color="grey.700" >
                    Showing data from <span className="font-semi underline">{subDays(new Date(), 7).toDateString()}</span> to <span className='underline'>today</span>.
                </Typography>
            </Stack>

            <Button 
                sx={styles.button} 
                variant="contained" 
                title="Settings" 
                startIcon={<DateRange />} 
                onClick={handleOnHeaderButtonClick}
            >
                Filter by date
            </Button>
        </Stack>

    )
}

const styles={

    button:{
        color: 'primary.main',
        boxShadow: "none",
        backgroundColor: 'secondary.main',
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: 'secondary.light'
        }
    }

}
